import React from "react";
import ImgHeader from "../ImgHeader";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import { H1, H3 } from "../Headers";
import WithHelperBar from "../WithHelperBar";

const guideUrl = "https://support.skyward.com/files/sites/ProfessionalServices/Partner-Branding.pdf";

export default () => {
  return (
    <>
      <ScrollToTopOnMount />
      <ImgHeader url="/static/img/SkywardBranding.png" shadowOpacity={0.4}>
        <H1>Partner Branding + PR/Social Media Guide</H1>
      </ImgHeader>
      <WithHelperBar>
        <H3>
          {"Download "}
          <a href={guideUrl} target="_blank" rel="noreferrer noopener">
            the guide here!
          </a>
        </H3>
      </WithHelperBar>
    </>
  );
};
